var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{attrs:{"value":_vm.value,"type":"daterange","range-separator":"-","start-placeholder":"开始日期","end-placeholder":"结束日期"},on:{"change":_vm.changeHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }